import graph from "@irati/utils/services/graph"
import PBService from "@irati/utils/services"
import client, {QueryOptions} from "@irati/utils/services/apollo"
import {Wallet, WalletEntityType, WalletList} from "@irati/types"

import walletQuery, {walletQueryKey} from "./query/wallet"
import {toString as userWalletQuery} from "./query/UserWalletList"
import {toString as tenantWalletQuery} from "./query/TenantWalletList"
import {toString as giftUserWalletCreditMutation} from "./mutation/giftUserWalletCredit"
import {toString as sendCreditToUserMutation} from "./mutation/sendCreditToUser"
import statementItemsQuery, {statementItemsQueryKey} from "./query/StatementItems"
import walletErrorHandler from "../helpers/errors/walletErrorHandler"

class WalletService extends PBService {
  get(
    entityId: string,
    currency: string,
    entityType: WalletEntityType = WalletEntityType.User,
    options: QueryOptions = {}
  ): Promise<Wallet> {
    return client
      .query({
        ...options,
        query: walletQuery,
        variables: {userId: entityId, currency, entityType, entityId}
      })
      .then(({data}) => {
        return data[walletQueryKey]
      })
  }

  giftUserWalletCredit(userId: string, amount: number, currency: string, reason: string) {
    return graph({query: giftUserWalletCreditMutation, variables: {userId, amount, currency, reason}})
  }

  sendCreditToUser(senderId: string, receiverId: string, amount: number, currency: string) {
    return graph({query: sendCreditToUserMutation, variables: {senderId, receiverId, amount, currency}})
  }

  userWalletList(userId: string): Promise<WalletList> {
    return graph({query: userWalletQuery, variables: {userId}}).then((res) => res.userWalletList)
  }

  tenantWalletList(tenantId: string) {
    return graph({query: tenantWalletQuery, variables: {tenantId}}).then((res) => res.tenantWalletList)
  }

  statementItems(walletId: string, cursor?: string, options: QueryOptions = {}) {
    return client
      .query({...options, query: statementItemsQuery, variables: {walletId, cursor}})
      .then(({data}) => data[statementItemsQueryKey])
  }
}

const walletService = new WalletService({errorHandlers: [walletErrorHandler]})

export const getWallet = walletService.get
export const giftUserWalletCredit = walletService.giftUserWalletCredit
export const sendCreditToUser = walletService.sendCreditToUser
export const getUserWalletList = walletService.userWalletList
export const getTenantWalletList = walletService.tenantWalletList

export default walletService
